/**
 * CarPlayContext — web/Electron stub.
 *
 * On iOS, Metro automatically resolves this to CarPlayContext.ios.tsx which
 * contains the full react-native-carplay integration.
 *
 * This stub exists so that non-iOS bundlers (webpack/Electron) never try to
 * process react-native-carplay or react-native internals, which use Flow type
 * syntax that Babel cannot parse outside of a React Native environment.
 */

import React, { createContext, useContext } from 'react';

const CarPlayCtx = createContext<null>(null);

export function useCarPlay(): null {
  return useContext(CarPlayCtx);
}

export function CarPlayProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
